import { render, staticRenderFns } from "./testComponents.vue?vue&type=template&id=56a8fc68&scoped=true"
import script from "./testComponents.vue?vue&type=script&lang=js"
export * from "./testComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8fc68",
  null
  
)

export default component.exports